// @flow

import { all, takeLatest } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import fetchNotificationsSagas from './fetchNotifications';
import updateSearchNotificationSagas from './updateSearchNotification';
import clientConfig from '~/../parameters/client/config';
import WebPushNotificationsApi from '~/sdk/notifications/webPush/ApiNotifications';
import { FETCH_SEARCH_NOTIFICATIONS, UPDATE_SEARCH_NOTIFICATION } from '../actionTypes';

const webPushNotificationsApi = new WebPushNotificationsApi(clientConfig.notificationApi);

export default function* searchNotificationsSagas(): Saga<void> {
  yield all([
    takeLatest(FETCH_SEARCH_NOTIFICATIONS, fetchNotificationsSagas(webPushNotificationsApi)),
    takeLatest(UPDATE_SEARCH_NOTIFICATION, updateSearchNotificationSagas(webPushNotificationsApi)),
  ]);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/sagas/index.js